import Header from './components/Header';
import HeroSection from './components/HeroSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <CarouselSection />
        <FeaturesSection />
        <RankingSection />
        <AppSection />
        <FaqSection />
        <CardsSection />
        <UpdatesSection />
        <AboutSection />
        <TopicsSection />
        <CommentsSection />
        <IndexSection />
        <ContactSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}